// Floor API functions
import { getData, deleteData, postData, putData } from '../apiClient';

// Get floors with pagination
export const getFloorWithPagination = async ({ page = 1, limit = 10, search = '' }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search
        });

        const result = await getData(`/floor/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get floors API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: [],
                totalPages: 1,
                prevPage: false,
                nextPage: false,
                totalDocs: 0,
                page: 1
            }
        };
    }
};

// Get single floor by ID
export const getFloorById = async (id) => {
    try {
        const result = await getData(`/floor/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get floor by ID API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};

// Create new floor
export const createFloor = async ({ data }) => {
    try {
        const result = await postData("/floor/create-floor", data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Create floor API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.errors : error.message,
                status: error.status,
            },
        };
    }
};

// Update floor
export const updateFloor = async ({ id, data }) => {
    try {
        const result = await putData(`/floor/update-floor/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error('Update floor API error:', error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.errors : error.message,
                status: error.status,
            },
        };
    }
};

// Delete floor
export const deleteFloor = async ({ id }) => {
    try {
        const result = await deleteData(`/floor/delete-floor/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Delete floor API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};